export enum PhysicalInventoryStateEnums {
  open = 1,
  close = 2,
}
